import React, { useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Login = () => {
  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const redirect = params.get('redirect') || '/';

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  if (isAuthenticated) {
    navigate(redirect, { replace: true });
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const res = await login(username.trim(), password);
    setLoading(false);
    if (res.ok) {
      navigate(redirect, { replace: true });
    } else {
      setError(res.message || '登入失敗');
    }
  };

  return (
    <div className="container" style={{ maxWidth: 420 }}>
      <h2 className="mt-4 mb-3">管理員登入</h2>
      <form onSubmit={onSubmit} className="card p-3 shadow-sm">
        <div className="mb-3">
          <label className="form-label">用戶名</label>
          <input className="form-control" value={username} onChange={e => setUsername(e.target.value)} required />
        </div>
        <div className="mb-3">
          <label className="form-label">密碼</label>
          <input type="password" className="form-control" value={password} onChange={e => setPassword(e.target.value)} required />
        </div>
        {error && <div className="alert alert-danger py-2">{error}</div>}
        <div className="d-flex gap-2 align-items-center">
          <button type="submit" className="btn btn-primary" disabled={loading}>{loading ? '登入中…' : '登入'}</button>
          <Link to={redirect} className="btn btn-outline-secondary">取消</Link>
        </div>
      </form>
    </div>
  );
};

export default Login;
